/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaInPrescriptionDto } from './FormulaInPrescriptionDto';
import {
    FormulaInPrescriptionDtoFromJSON,
    FormulaInPrescriptionDtoFromJSONTyped,
    FormulaInPrescriptionDtoToJSON,
    FormulaInPrescriptionDtoToJSONTyped,
} from './FormulaInPrescriptionDto';

/**
 * 
 * @export
 * @interface GetFormulasInPrescriptionResponseDto
 */
export interface GetFormulasInPrescriptionResponseDto {
    /**
     * List of formulas in the prescription
     * @type {Array<FormulaInPrescriptionDto>}
     * @memberof GetFormulasInPrescriptionResponseDto
     */
    formulas: Array<FormulaInPrescriptionDto>;
}

/**
 * Check if a given object implements the GetFormulasInPrescriptionResponseDto interface.
 */
export function instanceOfGetFormulasInPrescriptionResponseDto(value: object): value is GetFormulasInPrescriptionResponseDto {
    if (!('formulas' in value) || value['formulas'] === undefined) return false;
    return true;
}

export function GetFormulasInPrescriptionResponseDtoFromJSON(json: any): GetFormulasInPrescriptionResponseDto {
    return GetFormulasInPrescriptionResponseDtoFromJSONTyped(json, false);
}

export function GetFormulasInPrescriptionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFormulasInPrescriptionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'formulas': ((json['formulas'] as Array<any>).map(FormulaInPrescriptionDtoFromJSON)),
    };
}

export function GetFormulasInPrescriptionResponseDtoToJSON(json: any): GetFormulasInPrescriptionResponseDto {
    return GetFormulasInPrescriptionResponseDtoToJSONTyped(json, false);
}

export function GetFormulasInPrescriptionResponseDtoToJSONTyped(value?: GetFormulasInPrescriptionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formulas': ((value['formulas'] as Array<any>).map(FormulaInPrescriptionDtoToJSON)),
    };
}

